import * as components from './'
export default components